import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {ErrorService} from '../common/error.service';
import {connectApi} from '../common/connect-api';
import {DocumentsService} from '../common/documents.service';
import {NavigationService} from '../navigation.service';


@Component({
    selector: 'dp-connect-activation',
    templateUrl: './connect-activation.component.html',

})
export class ConnectActivationComponent implements OnInit {

    message: string = '';

    constructor(public route: ActivatedRoute,
                public router: Router,
                private httpClient: HttpClient,
                private documentService: DocumentsService,
                private navigationService: NavigationService) {
    }

    ngOnInit(): void {
        this.route.paramMap.subscribe((paramMap: any) => {
            let connectToken = paramMap.params ? paramMap.params['token'] : undefined;
            if (!connectToken) {
                this.router.navigate(['./login']);
            }
            else {
                this.validateLink(connectToken);
            }
        });
    }

    validateLink(connectToken: string): void {
        this.httpClient.get(`${connectApi.validate}/${connectToken}`, undefined).subscribe(
            (response: any) => {
                if (response['ConnectTokenInfo']) {
                    let connectTokenInfo = response['ConnectTokenInfo'];
                    let nextState = this.navigationService.getNextStep(connectToken);
                    if (connectTokenInfo.registeredUser) {
                        this.router.navigate(['./login'], {
                            state: {
                                loginId: connectTokenInfo.loginId,
                                nextState: nextState,
                                connectToken: connectToken
                            }
                        });
                    } else {
                        this.router.navigate(['./register'], {
                            state: {
                                loginId: connectTokenInfo.loginId,
                                nextState: nextState,
                                connectToken: connectToken
                            }
                        });
                    }
                }
            },
            (error) => {
                this.router.navigate(['./login']);
            }
        );

        //this.router.navigate(['./login'], { state: { loginId: 'hi@hi.com' , nextState : 'shared-docs' }});

    }


}
